import React from 'react';

const ACT = () => {
  return(
      <div>
        <h1>ACT WORKS!</h1>
      </div>
    )
}

export default ACT;